export const Locations = [
  "All Location",
  "China",
  "Anhui",
  "Beijing",
  "Chongqing",
  "Fujian",
  "Gansu",
  "Guangdong",
  "Guangxi",
  "Guizhou",
  "Hainan",
  "Hebei",
  "Heilongjiang",
  "Henan",
  "Hubei",
  "Hunan",
  "Inner Mongolia",
  "Jiangsu",
  "Jiangxi",
  "Jilin",
  "Liaoning",
  "Ningxia",
  "Qinghai",
  "Shaanxi",
  "Shandong",
  "Shanghai",
  "Shanxi",
  "Sichuan",
  "Tianjin",
  "Tibet",
  "Xinjiang",
  "Yunnan",
  "Zhejiang"
]

export const industyCls = [
  "All Class",
  "Corn",
  "Corn Starch",
  "Cotton",
  "DDGS",
  "Egg",
  "Paddy",
  "Palm Oil",
  "Pigs",
  "Rape Oil",
  "Rapeseed",
  "Rapeseed Meal",
  "Rice",
  "Soybean",
  "Soybean Meal",
  "Soybean Oil",
  "Wheat",
  "White Sugar",
  "Laterite-Nickel ore",
  "Billet Cost Index",
  "Casting Scrap",
  "chrome ore",
  "ferronickel",
  "HMS",
  "HRC Cost Index",
  "International Scrap",
  "Iron Ore",
  "manganese ore",
  "Medium plate Cost Index",
  "molybdenum",
  "Pig iron Cost Index",
  "Rare Earth",
  "Rebar Cost Index",
  "Slab Cost Index",
  "titanium",
  "Tungsten",
  "vanadium",
  "wire rod Cost Index",
  "Tea",
  "Green Tea",
  "Flavoured",
  "oolong Tea",
  "pu-er Tea",
  "Black Tea",
  "Alcoholic Drinks",
  "Baijiu",
  "Spirits",
]

export const allPeriod = [
  "All Period",
  "day",
  "half month",
  "month",
  "Ten days",
  "week",
  "year"
]
